module.exports = __webpack_public_path__ + "static/VinciConstruction-f7c4d8bada48603eb1496abc407b677c.png";